module.exports = __webpack_public_path__ + "img/eye.e8585564.svg";